/**
 * Leistungen (Element pa-services): Die Zeile, die gerade durch die Bildschirmmitte läuft, bekommt .is-active –
 * dieselbe Hervorhebung wie beim Überfahren mit der Maus (Verlaufslinie zieht ein, Nummer füllt sich).
 * So erlebt man den Effekt auch am Handy und beim reinen Scrollen am Desktop. Immer nur eine Zeile aktiv.
 */
import { qsa } from '../utils/dom.js';

export function init() {
	const items = qsa('.pa-service');
	if (!items.length || !('IntersectionObserver' in window)) return;

	const visible = new Set();
	const update = () => {
		// Von den Zeilen im Mittelband gewinnt die, deren Mitte der Bildschirmmitte am nächsten ist
		const mid = window.innerHeight / 2;
		let best = null;
		let bestDist = Infinity;
		visible.forEach((el) => {
			const r = el.getBoundingClientRect();
			const dist = Math.abs(r.top + r.height / 2 - mid);
			if (dist < bestDist) { best = el; bestDist = dist; }
		});
		items.forEach((el) => el.classList.toggle('is-active', el === best));
	};

	// Mittelband: mittlere 30 % der Fensterhöhe
	const io = new IntersectionObserver((entries) => {
		entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
		update();
	}, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });

	items.forEach((el) => io.observe(el));
}
